import { RolesRoute } from './-route-wrappers';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/settings/roles/')({
  component: RolesRoute,
});
